import React, { useEffect, useCallback, useState} from 'react';
import ipfs from 'decentralized/Ipfs.js';
import {connect} from 'react-redux';

const uploadFile = (file) => {
    return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onloadend = async (e) => {
            setTimeout(async () => {
                let hash = await ipfs.addArrayBuffer(reader.result);
                resolve(hash);
            }, 1000);
        };
    });
};
 
const ImageHandler = ({imageHash, setImageHash, placeholder="Drag thumbnail"}) => { 
    const onDrop = useCallback(async (ev) => {
        if (!ev.dataTransfer) {
            return;
        }
        ev.stopPropagation();
        ev.preventDefault();
        ev.dataTransfer.effectAllowed = "none";
        ev.dataTransfer.dropEffect = "none";
        
        if (ev.dataTransfer.items) {
            // Use DataTransferItemList interface to access the file(s)
            let len = ev.dataTransfer.items.length;
            for (var i = 0; i < len; i++) {
                // If dropped items aren't files, reject them
                if (ev.dataTransfer.items[i].kind === 'file') {
                    let hash = await uploadFile(ev.dataTransfer.items[i].getAsFile());
                    setImageHash(hash);
                    return;
                }
            }
        }
 
    }, [setImageHash]);
    
    let inner = '';
    if (imageHash) {
        inner = (
            <div className="inner">
              <img src={ipfs.getHashUrl(imageHash)}/>
              <span className="drag-placeholder">{placeholder}</span>
            </div>
        );
    } else {
        inner = (
            <span>
              {placeholder}
            </span>
        );
    }
    return (
        <div className="image-handler">
          <div
            onDragOver={(e) => {
                e.stopPropagation();
                e.preventDefault();
                e.dataTransfer.effectAllowed = "none";
            }}
            onDragEnter={(e) => {
                e.stopPropagation();
                e.preventDefault();
                e.dataTransfer.effectAllowed = "none";
                e.dataTransfer.dropEffect = "none";
            }}
            onDrop={onDrop}
            className={imageHash ? "drop-here loaded" : "drop-here"}>
            {inner}
         </div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ImageHandler);
